export const getEventTemplates = (axiosInstance, start, count) => {
    const params = {
        start: start ?? 0,
        count: count ?? 15,
    };
    return axiosInstance.get('v1/tms/events/templates', {
        params,
    });
};

export const getEventTemplatesForClub = (axiosInstance, clubId, start, count, sportTypeId) => {
    const params = {
        start: start ?? 0,
        count: count ?? 15,
        sportTypeId,
    };
    return axiosInstance.get(`v1/tms/events/templates/club/${clubId}`, {
        params,
    });
};

export const getEventTemplate = (axiosInstance, templateId) => {
    return axiosInstance.get(`v1/tms/events/templates/${templateId}`);
};

export const deleteEventTemplate = (axiosInstance, templateId) => {
    return axiosInstance.delete(`v1/tms/events/templates/${templateId}`);
};

export const getEventTemplateTags = (axiosInstance) => {
    return axiosInstance.get('v1/tms/events/templates/tags');
};

export const getEventTours = (axiosInstance) => {
    return axiosInstance.get('v1/tms/events/templates/tours');
};

export const saveEventTemplate = (axiosInstance, eventTemplateValues) => {
    if (eventTemplateValues.id) {
        return axiosInstance.put(`v1/tms/events/templates/${eventTemplateValues.id}`,
            eventTemplateValues);
    }

    return axiosInstance.post('v1/tms/events/templates',
        eventTemplateValues);
};
